// Unit-of-measure conversion. Quantities are integers in the item's base unit
// (CLAUDE.md rule 7); pack levels carry how many base units they hold.
export const UOM_CODES = ['EA', 'IP', 'CS', 'PL'];
export const UOM_LABEL = {
    EA: 'Each',
    IP: 'Inner pack',
    CS: 'Case',
    PL: 'Pallet',
};
/** Converts a quantity in `uom` to base units; throws on an unknown pack level. */
export function toBase(qty, uom, levels) {
    if (!Number.isInteger(qty))
        throw new Error('Quantities must be whole numbers');
    const level = levels.find((l) => l.uom === uom);
    if (!level)
        throw new Error(`Unknown unit of measure ${uom}`);
    return qty * level.qtyPerBase;
}
/** Breaks a base quantity into the largest whole pack levels (e.g. 3 PL, 2 CS, 5 EA). */
export function breakdown(baseQty, levels) {
    const sorted = [...levels].sort((a, b) => b.qtyPerBase - a.qtyPerBase);
    let rest = baseQty;
    const out = [];
    for (const l of sorted) {
        if (l.qtyPerBase <= 0)
            continue;
        const n = Math.floor(rest / l.qtyPerBase);
        if (n > 0) {
            out.push({ uom: l.uom, qty: n });
            rest -= n * l.qtyPerBase;
        }
    }
    return out;
}
export const mmToIn = (mm) => mm / 25.4;
export const gToLb = (g) => g / 453.59237;
export const inToMm = (inch) => Math.round(inch * 25.4);
export const lbToG = (lb) => Math.round(lb * 453.59237);
//# sourceMappingURL=units.js.map